import SuggestionPanelComponent, { SUGGESTION_PANEL_BASE_HTML_CLASS } from "./suggestion_panel_component";

// ForgotPanel — request a password-reset link. Enumeration-uniform: the host always reports
// "if that address has an account, we've emailed a link", so this panel never learns whether
// the account exists. Back returns to the password panel.
export class ForgotPanel extends SuggestionPanelComponent {
  static get config() {
    return {
      componentTypeKey: "SuggestionForgotPanel",
      baseHtmlClass: SUGGESTION_PANEL_BASE_HTML_CLASS,
      selector: ".suggestion_panel__panel--forgot",
      phase: "forgot",

      emailInputSelector: "input[type='email']",
      backSelector: ".suggestion_panel__back",
      statusSelector: ".suggestion_panel__status",
    };
  }

  constructor(id_or_element, host) {
    super(id_or_element, host, ForgotPanel.config);
    const config = ForgotPanel.config;

    this.emailInput = this.element.querySelector(config.emailInputSelector);
    this.statusEl = this.element.querySelector(config.statusSelector);

    this.element.addEventListener("submit", (event) => {
      if (event) event.preventDefault();
      this.host.requestPasswordReset(this.emailInput ? this.emailInput.value : "");
    });

    const back = this.element.querySelector(config.backSelector);
    if (back) back.addEventListener("click", (event) => {
      if (event) event.preventDefault();
      this.host.closeForgot();
    });
  }

  // Prefill from the address already in play, so the reset field isn't blank.
  prefillEmail(email) {
    if (!this.emailInput) return;
    if (this.emailInput.value) return;
    if (document.activeElement === this.emailInput) return;
    this.emailInput.value = email;
  }

  render() {
    const isActive = this.renderPanelVisibility();
    this.applyBusy([this.emailInput]);
    this.renderAuthStatus(this.statusEl);
    return isActive;
  }
}
